module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sessionTray"
  }, [_c('notification-bar', {
    attrs: {
      "text": _vm.notificationText
    },
    on: {
      "notification-click": _vm.onNotificationClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sessionList"
  }, _vm._l((_vm.presentationsGrouped), function(presentation, index) {
    return _c('div', {
      key: index
    }, [_c('sessioncard', {
      attrs: {
        "presentation": presentation
      }
    })], 1)
  })), _vm._v(" "), (_vm.isEmpty) ? _c('div', {
    staticClass: "background-message"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('str.NoSessionsAvailable')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('str.PleaseTryAgain')))]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/qr_code.png")
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retryUrl),
      expression: "retryUrl"
    }],
    staticClass: "input-retry",
    domProps: {
      "value": (_vm.retryUrl)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.retry($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retryUrl = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "spinner-container"
  }, [_c('spinner')], 1) : _c('button', {
    staticClass: "bt-retry",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v(_vm._s(_vm.$t('str.Go')))])])])]) : _vm._e(), _vm._v(" "), (!_vm.isReady) ? _c('spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b8154db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionsTray.vue
// module id = 468
// module chunks = 0